import { PRODUCT_FORM_TYPE_TEXT } from "./constants";

const SHOP_AUTO_PARAMETERS = {
  "67639189fd2e8b810942df8b": {
    "676479efc86afd6a2d54e4b8": [
      { name: "Brand", defaultValue: "Hermès" },
      { name: "Type", defaultValue: "Bag" },
      { name: "Options", defaultValue: "Full set" },
      { name: "Condition", defaultValue: "New" },
      { name: "Material" },
      { name: "Color" },
      { name: "Model" },
      { name: "Size" },
      { name: "Hardware" },
      { name: "Year" },
      { name: "Date Stamp" },
    ],
    "676479e3c86afd6a2d54e4b6": [
      { name: "Brand" },
      { name: "Type" },
      { name: "Options" },
      { name: "Size" },
      { name: "Condition", defaultValue: "New" },
      { name: "Year" },
    ],
    "676479d4c86afd6a2d54e4b4": [
      { name: "Brand" },
      { name: "Type" },
      { name: "Case material" },
      { name: "Water resistance" },
      { name: "Mechanism type" },
      { name: "Capacity" },
      { name: "Band material" },
      { name: "Options" },
      { name: "Condition", defaultValue: "New" },
      { name: "Gender" },
      { name: "Year" },
      { name: "Dial color" },
      { name: "Caliber" },
      { name: "Power reserve" },
      { name: "Case diameter" },
      { name: "Glass" },
      { name: "Product ID" },
    ],
  },
  "67643c55da6082114a6e3e8a": {
    "676d2a993d46fae0100c0c22": [
      { name: "Бренд", defaultValue: "Hermès" },
      { name: "Тип", defaultValue: "Сумка" },
      { name: "Комплектация", defaultValue: "Полный комплект" },
      { name: "Состояние", defaultValue: "Новое" },
      { name: "Материал" },
      { name: "Цвет" },
      { name: "Модель" },
      { name: "Размер" },
      { name: "Фурнитура" },
      { name: "Год" },
      { name: "Штамп" },
    ],
    "676d2a933d46fae0100c0bac": [
      { name: "Бренд" },
      { name: "Тип" },
      { name: "Комплектация" },
      { name: "Размер" },
      { name: "Состояние", defaultValue: "Новое" },
      { name: "Год" },
    ],
    "676d2a853d46fae0100c0a96": [
      { name: "Бренд" },
      { name: "Тип" },
      { name: "Материал корпуса" },
      { name: "Водонепроницаемость" },
      { name: "Тип механизма" },
      { name: "Данные на часах" },
      { name: "Материал ремешка" },
      { name: "Комплектация" },
      { name: "Состояние", defaultValue: "Новое" },
      { name: "Пол" },
      { name: "Год" },
      { name: "Цвет циферблата" },
      { name: "Калибр" },
      { name: "Запас батареи" },
      { name: "Диаметр корпуса" },
      { name: "Стекло" },
      { name: "Идентификатор продукта" },
    ],
  },
};

export function normalizeParameterName(name) {
  return `${name || ""}`.trim().toLowerCase();
}

export function getInitialCategory(category) {
  if (!category) return null;

  if (category.parents?.length > 0) {
    return category.parents[category.parents.length - 1];
  }

  return category;
}

export function getAutoParameterDefinitions(shopId, categories = []) {
  const shopConfig = SHOP_AUTO_PARAMETERS[shopId];

  if (!shopConfig || categories.length === 0) {
    return [];
  }

  const uniqueParameters = new Map();

  categories.forEach((category) => {
    const initialCategory = getInitialCategory(category);
    const categoryParameters = shopConfig[initialCategory?._id] || [];

    categoryParameters.forEach((parameter) => {
      const normalizedName = normalizeParameterName(parameter.name);

      if (!uniqueParameters.has(normalizedName)) {
        uniqueParameters.set(normalizedName, parameter);
      }
    });
  });

  return Array.from(uniqueParameters.values());
}

export function getAutoParameterState(shopId, product) {
  const definitions = getAutoParameterDefinitions(shopId, product?.categories || []);
  const existingNames = new Set(
    (product?.parameters || []).map((parameter) =>
      normalizeParameterName(parameter.title)
    )
  );

  const existingCount = definitions.filter((parameter) =>
    existingNames.has(normalizeParameterName(parameter.name))
  ).length;

  return {
    definitions,
    totalCount: definitions.length,
    existingCount,
    missingDefinitions: definitions.filter(
      (parameter) => !existingNames.has(normalizeParameterName(parameter.name))
    ),
  };
}

export function createAutoParameter(definition, createId) {
  return {
    _id: createId(),
    title: definition.name,
    value: definition.defaultValue || "",
    type: PRODUCT_FORM_TYPE_TEXT,
    isAutoParameter: true,
  };
}

export function isEmptyAutoParameter(parameter) {
  if (!parameter?.isAutoParameter) return false;

  if (parameter.type?.type === "boolean") return false;

  return `${parameter.value || ""}` === "";
}

export function getSavableParameters(parameters = []) {
  return parameters.filter((parameter) => !isEmptyAutoParameter(parameter));
}
